export const acceptHighestBid = async (metaspaceNFTMarketplaceContract, address, index) => {
  return await metaspaceNFTMarketplaceContract.acceptHighestBid(address, index)
}

export const bid = async (metaspaceNFTMarketplaceContract, address, index, amount) => {
  return await metaspaceNFTMarketplaceContract.bid(address, index, amount)
}

export const bidWithMatic = async (metaspaceNFTMarketplaceContract, address, index, amount, price) => {
  return await metaspaceNFTMarketplaceContract.bid(address, index, amount, { value: price })
}
